import { Box, Container, Grid, Typography } from '@mui/material';
import React from 'react';
import { Trans, useTranslation } from 'react-i18next';
import SwipeDownIcon from '../../../common/SwipeDownIcon';
import AnimatedTypography from '../../../core/AnimatedTypography';


interface LandingProps {
}

const Landing: React.FC<LandingProps> = ({ }) => {
    const { t } = useTranslation();
    return (
        <Box
            sx={{
                marginTop: { xs: "-72px", sm: "-80px" },
                backgroundImage: `url(${process.env.PUBLIC_URL}/images/gallery/full/${4}.jpg)`,
                backgroundPosition: "center",
                backgroundSize: "cover",
                position: "relative",
                // zIndex: 3,
                "&::before": {
                    background: "#2b2726ff",
                    position: "absolute",
                    top: 0,
                    left: 0,
                    width: "100%",
                    height: "100%",
                    zIndex: 1,
                    content: '""',
                    opacity: .55
                }
            }}
            pl={0}
            pr={0}
            width={"100vw"}
            height={"100vh"}
            marginLeft={"calc(50% - 50vw)"}
            display={"flex"}
            alignItems={"center"}
            justifyContent={"center"}>
            <Grid
                pt={6}
                pb={6}
                zIndex={10}
                container
                justifyContent={"flex-start"}>
                <Container maxWidth="xl">
                    <AnimatedTypography color={"#eef0f5ff"} variant='h1' lineHeight={1.1} fontWeight={600} maxWidth={700}
                        sx={{
                            textShadow: "#000000ff 1px 0 10px"
                        }}>
                        <Trans
                            i18nKey="aboutUs.basic.title"
                            components={{
                                highlight: <Typography component="span" variant='h1' color="primary.main" fontWeight={700} fontStyle={"italic"} />
                            }}>
                        </Trans>
                    </AnimatedTypography>
                    <Box mt={4} mb={4} maxWidth={700}>
                        <AnimatedTypography color={"#d6d8e0ff"} fontWeight={600} variant='h6' sx={{ textShadow: "#000000ff 1px 0 10px" }}>
                            {t("aboutUs.basic.row1")}
                        </AnimatedTypography>

                        <AnimatedTypography mt={2} color={"#d6d8e0ff"} fontWeight={600} variant='h6' sx={{ textShadow: "#000000ff 1px 0 10px" }}>
                            <Trans
                                i18nKey="aboutUs.basic.row2"
                                components={{
                                    highlight: <Typography component="span" color="primary.main" fontWeight={700} fontStyle={"italic"} sx={{ textShadow: "#000000ff 1px 0 10px" }} />
                                }}>
                            </Trans>
                        </AnimatedTypography>
                    </Box>
                </Container>
            </Grid>
            <SwipeDownIcon />
        </Box>
    )
}

export default Landing;